/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";
import { Button, PanelBody, Modal, Spinner } from "@wordpress/components";
import { Fragment, useState } from "@wordpress/element";
import apiFetch from "@wordpress/api-fetch";

/**
 * Notices
 */
import { useDispatch } from "@wordpress/data";
import { store as noticesStore } from "@wordpress/notices";

const Sidebar = () => {
	const [isModarlOpen, setModelState] = useState(false);
	const openModal = () => setModelState(true);
	const closeModal = () => setModelState(false);

	const [isOnRequest, setOnRequest] = useState(false);
	const loading = () => setOnRequest(true);
	const loaded = () => setOnRequest(false);

	const { createNotice } = useDispatch(noticesStore);

	// const goToTab = (tabName) => {
	// 	let target = document.querySelector(`#tab-panel-0-${tabName}`);
	// 	target.click();
	// };

	const purge = async () => {
		let purgeConfigs = window.ahscUtils.const.purger;

		//spinner
		loading();

		const data = new FormData();
		data.append("action", "ahcs_clear_cache");
		data.append("ahsc_nonce", purgeConfigs.ahsc_nonce);
		data.append("ahsc_to_purge", purgeConfigs.ahsc_topurge);

		let purgeRequest = await apiFetch({
			method: "POST",
			url: purgeConfigs.ahsc_ajax_url,
			body: data,
		}).then((esit) => {
			if (esit.code >= 200) {
				createNotice(esit.type, esit.message, { isDismissible: true });
				closeModal();
				loaded();
			}
		});
	};

	return (
		<Fragment>
			{/* first pb */}
			<PanelBody>
				<div className="ahsc-info">
					<h3>{__("Actions", "aruba-hispeed-cache")}</h3>

					<div className="ahsc-info-button-group">
						{/* <Button
							variant="secondary"
							isSecondary
							onClick={() => {
								goToTab("speed-test");
							}}
						>
							{__("Speed Test", "aruba-hispeed-cache")}
						</Button> */}

						<Button variant="primary" isPrimary onClick={() => openModal()}>
							{__("Purge entire cache", "aruba-hispeed-cache")}
						</Button>

						{/* <Button variant="primary" isPrimary target="_blank" href="bla bla bla bla bla">
							{__("Explore Otter Pro", "aruba-hispeed-cache")}
						</Button> */}
					</div>
				</div>
			</PanelBody>
			<>
				{isModarlOpen && (
					<Modal title={__("Are you sure?", "aruba-hispeed-cache")} onRequestClose={closeModal}>
						<p>
							{__(
								"You are about to purge the entire cache. Do you want to continue?",
								"aruba-hispeed-cache"
							)}
						</p>
						<Button variant="primary" onClick={purge}>
							{__("Purge Cache", "aruba-hispeed-cache")}
							{isOnRequest && <Spinner />}
						</Button>
					</Modal>
				)}
			</>
		</Fragment>
	);
};

export default Sidebar;
